module.exports = {"330327100":"灵溪镇","330327103":"宜山镇","330327104":"钱库镇","330327107":"金乡镇","330327112":"藻溪镇","330327113":"桥墩镇","330327116":"矾山镇","330327117":"赤溪镇","330327118":"马站镇","330327122":"望里镇","330327123":"炎亭镇","330327124":"大渔镇","330327125":"莒溪镇","330327126":"南宋镇","330327127":"霞关镇","330327128":"沿浦镇","330327216":"凤阳畲族乡","330327218":"岱岭畲族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330327.json
// module id = 1075
// module chunks = 0